import { TenantFeatureFlags } from "./tenant";

export class Cuenta {
    constructor(
        public readonly Id: number,
        public readonly Codigo: string | null,
        public readonly EsCuentaCorrienteInterna: boolean,

        public MonedaId: number | null,
        public readonly MonedaCodigo: string | null,
        public readonly BancoId: number | null,
        public readonly BancoNombre: string | null,
        public readonly Titular: string | null,
        public readonly NumeroCuenta: string | null,
        public readonly Alias: string | null,
        public readonly ClaveBancaria: string | null,
        public Activo: boolean | null,

        public PersonaId: number | null,
        public readonly PersonaNombre: string | null,
        public readonly ProveedorId: number | null,
        public readonly Proveedor: string | null,
        public readonly ComunidadId: number | null,
        public readonly Comunidad: string | null,
        public readonly ConsorcioId: number | null,
        public readonly Consorcio: string | null,
        public readonly UnidadFuncionalId: number | null,
        public readonly UnidadFuncional: string | null
    ) { }
}

export class SaveCuentaDto {
    constructor(
        public readonly Id: number,
        public readonly Codigo: string | null,
        public readonly MonedaId: number | null,
        public readonly BancoId: number | null,
        public readonly PersonaId: number | null,
        public readonly ProveedorId: number | null,
        public readonly ComunidadId: number | null,
        public readonly ConsorcioId: number | null,
        public readonly UnidadFuncionalId: number | null,
        public readonly NumeroCuenta: string | null,
        public readonly Titular: string | null,
        public readonly Alias: string | null,
        public readonly ClaveBancaria: string | null,
        public readonly Activo: boolean,
        public readonly EsCuentaCorrienteInterna: boolean
    ) { }
}

export class SearchCuentaRequest {
    constructor(
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,
        public readonly Codigo: string | null,
        public readonly Alias: string | null,
        public readonly ClaveBancaria: string | null,
        public readonly Titular: string | null,
        public readonly BancoId: number | null,
        public readonly MonedaId: number | null,
        public readonly PersonaId: number | null,
        public readonly ProveedorId: number | null,
        public readonly ComunidadId: number | null,
        public readonly ConsorcioId: number | null,
        public readonly UnidadFuncionalId: number | null,
        public readonly TenantId: number | null,
        public readonly VerSoloActivos: boolean | null,
        public readonly VerSoloCuentaCorrienteInterna: boolean | null,
        public readonly VerSoloCuentasConSaldo: boolean | null,
        public readonly VerSoloCuentaImputables: boolean | null
    ) { }
}

export class SearchCuentaResponse {
    constructor(
        public readonly count: number,
        public readonly result: Cuenta[]
    ) { }
}

export class DialogCuentaSearchComponentRequestDto {
    constructor(
        public readonly FeatureFlags: TenantFeatureFlags,
        public readonly MostrarTabPersona: boolean | null,
        public readonly MostrarTabProveedor: boolean | null,
        public readonly MostrarTabConsorcio: boolean | null,
        public readonly MostrarTabComunidad: boolean | null,
        public readonly MostrarTabUnidadFuncional: boolean | null,
        public readonly MonedaId: number | null,
        public readonly Moneda: string | null,
        public readonly VerCuentasConSaldo: boolean | null
    ) { }
}

export class DialogCuentaSearchComponentResponseDto {
    constructor(
        public readonly Cancelled: boolean,
        public readonly Item: Cuenta | null
    ) { }
}
